import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TermService {
  path = '@cec-api/term';
  constructor(private http: HttpClient) {}

  async acceptByUser(version: string, accepted: Boolean): Promise<any> {
    return this.http.post(this.path, { version, accepted }).toPromise();
  }

  async acceptByCPF(obj: any): Promise<any> {
    return this.http.post(this.path + '/accept', obj).toPromise();
  }
}
